import * as React from 'react'

import type { Callback, EventType } from 'modules/core/lib/pubSub'
import { subscribe, unsubscribe } from 'modules/core/lib/pubSub'

export default function useSubscribe(events: EventType[], callback: Callback) {
  return React.useEffect(() => {
    subscribe(events, callback)

    return () => {
      unsubscribe(callback)
    }
  }, [events, callback])
}
